import React, { Component } from 'react'
import { connect } from 'react-redux'
import UsersForm from '../../../components/forms/UserForm'

import {
    isAllowed,
    req,
    ADMIN,
    REPORTS,
    USER,
    SNAP_V2,
    CAR_FORM_V1,
    CAR_FORM_V2,
    CAR_FORM_V3
} from '../../../util'

import { toggleLoading, toast } from '../../../redux/actions'

const mapStateToProps = state => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    toggleLoading: () => dispatch(toggleLoading()),
    toast: msg => dispatch(toast({ msg }))
})


class UsersUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                name: '',
                username: '',
                password: '',
                phone: '',
                status: false,
                roles: []
            },
        }
    }


    onTextChange = (evt, t) => this.setState({ user: { ...this.state.user, [evt.target.name]: evt.target.value } })

    onCheckChange = (role) => (checked) => {
        let { user } = this.state;
        if (role === 'status') return this.setState({ user: { ...this.state.user, status: checked.target.checked } })
        console.log(checked.target.checked)
        let index = user.roles.indexOf(role)
        if (index >= 0) {
            user.roles.splice(index, 1)
        } else {
            user.roles.push(role)
        }
        this.setState({ user })
    }


    createRoles = (roles = []) => ({
        ADMIN: roles.includes(ADMIN),
        USER: roles.includes(USER),
        REPORTS: roles.includes(REPORTS),
        SNAP_V2: roles.includes(SNAP_V2),
        CAR_FORM_V1: roles.includes(CAR_FORM_V1),
        CAR_FORM_V2: roles.includes(CAR_FORM_V2),
        CAR_FORM_V3: roles.includes(CAR_FORM_V3)
    })


    getUser = id => {
        let { toggleLoading, toast } = this.props;
        toggleLoading()
        req('GET', `auth/users/${id}`).then(res => {
            let { success, msg, user } = res;
            if (success) {
                this.setState({
                    user,
                })
                toggleLoading()
            } else {
                toggleLoading()
                toast(msg)
            }
        }).catch(e => {
            toggleLoading()
            toast('لايمكن الوصول الى الشبكة')
        })
    }

    goBack = (e) => {
        e.preventDefault()
        this.props.history.push("/settings/users/edit")
    }

    onSubmit = (evt) => {
        evt.preventDefault()
        let { toggleLoading, toast } = this.props;
        let { user } = this.state;
        if (user.status) { user.status = 1 } else { user.status = 0 }
        toggleLoading()
        req('PUT', 'auth/users', user).then(res => {
            let { success, msg } = res;
            if (success) {
                toggleLoading();
                this.props.history.push("/settings/users/edit")
                toast(`تم تحديث المستخدم ${user.name}`)
            } else {
                toggleLoading();
                toast(msg || "هنالك مشكلة في التطبيق")
            }
        }).catch(e => {
            toggleLoading()
            toast('هنالك مشكلة في الشبكة !')
            console.error(e)
        })
    }

    componentWillMount = () => {
        let { user, history } = this.props;
        let { id } = this.props.match.params;
        if (!user.loggedIn) return history.push('/login')
        if (!isAllowed(user.user, ["USER"])) return history.push('/unauthrized')
        // this.getBranches()
        this.getUser(id)
    }

    handleSelectChange = field => value => this.setState({ [field]: value });

    render() {
        let { user } = this.state;
        if (user.status) { user.status = true } else { user.status = false }
        let roles = this.createRoles(user.roles)
        return (
            <UsersForm
                {...this.state}
                title='تعديل مستخدم'
                onTextChange={this.onTextChange}
                onCheckChange={this.onCheckChange}
                onSubmit={this.onSubmit}
                {...roles}
                {...user}
                update
                goBack={this.goBack}
                branchesOptions={[]}
                handleSelectChange={this.handleSelectChange}
            />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersUpdate)